import React, { useState } from 'react';
import { GridApiPro } from '@mui/x-data-grid-pro';
import { ColumnGroup } from '../components/datagridComponents/GridColumns';

const SidekickDataGridConfigContext = React.createContext({
  gridApiRef: undefined as React.MutableRefObject<GridApiPro>,
  setGridApiRef: (_gridApiRef: React.MutableRefObject<GridApiPro>) => {
    /* */
  },
  translationKey: '',
  showColumnsButton: false,
  columnVisibilityModel: {} as Record<string, boolean>,
  changeColumnVisibility: (_columnName: string, _visible: boolean) => {
    /* */
  },
  columnGroups: undefined as ColumnGroup[],
});

const SidekickDataGridConfigContextProvider = ({
  translationKey,
  columnVisibility,
  columnGroups,
  children,
}: {
  translationKey: string;
  columnVisibility?: Record<string, boolean>;
  columnGroups?: ColumnGroup[];
  children: JSX.Element;
}) => {
  const [gridApiRef, setGridApiRef] = useState<React.MutableRefObject<GridApiPro>>(undefined);
  const [columnsVisibility, setColumnsVisibility] = useState<Record<string, boolean>>(
    columnVisibility || {}
  );

  const changeColumnVisibility = (columnName: string, visible: boolean) => {
    if (columnName in columnsVisibility) {
      setColumnsVisibility({
        ...columnsVisibility,
        [columnName]: visible,
      });
    }
  };

  const contextValue = {
    gridApiRef,
    setGridApiRef,
    translationKey,
    showColumnsButton: Object.keys(columnsVisibility)?.length > 0,
    columnVisibilityModel: columnsVisibility,
    changeColumnVisibility,
    columnGroups,
  };

  return (
    <SidekickDataGridConfigContext.Provider value={contextValue}>
      {children}
    </SidekickDataGridConfigContext.Provider>
  );
};

export { SidekickDataGridConfigContext, SidekickDataGridConfigContextProvider };
